import script from "./done-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./done-button.vue?vue&type=script&setup=true&lang=ts"

import "./done-button.vue?vue&type=style&index=0&id=7ac196c2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ac196c2"]])

export default __exports__